module.exports = "g-property-card {\n  margin-right: 1%;\n  margin-bottom: 1%;\n  display: inline-block !important;\n  min-width: 25%; }\n"